// src/services/adminOrigins.js
// CORS global DSI — fan-out Worker Admin → Workers cibles
// Codes agrégés : 200 termine · 207 partiel · 502 echec · 503 aucune_cible_configuree

import { apiFetch } from './adminHttp';

/** GET /admin/origins — ORIGINES_VOIR */
export async function getOrigins() {
  return apiFetch('/admin/origins', {
    method: 'GET',
    acceptPartial: true,
  });
}

/**
 * POST /admin/origins — ORIGINES_MODIFIER
 * Body : { origin, label? } — id généré côté Worker (org_ + 32 hex)
 */
export async function createOrigin(payload) {
  return apiFetch('/admin/origins', {
    method: 'POST',
    body: JSON.stringify(payload),
    acceptPartial: true,
  });
}

/**
 * PATCH /admin/origins/:id — seuls label et status
 */
export async function patchOrigin(id, payload) {
  return apiFetch(`/admin/origins/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
    acceptPartial: true,
  });
}

/** POST /admin/origins/:id/deactivate */
export async function deactivateOrigin(id) {
  return apiFetch(`/admin/origins/${encodeURIComponent(id)}/deactivate`, {
    method: 'POST',
    body: JSON.stringify({}),
    acceptPartial: true,
  });
}

/**
 * POST /admin/origins/:id/reprise
 * Reprise uniquement vers cibles en échec/skip de la dernière propagation.
 */
export async function repriseOrigin(id) {
  return apiFetch(`/admin/origins/${encodeURIComponent(id)}/reprise`, {
    method: 'POST',
    body: JSON.stringify({}),
    acceptPartial: true,
  });
}
